/**
 * api/settings.js — query para a tela de Configurações.
 *
 * Endpoint coberto (F0-BE-2):
 *   GET /settings   — leitura das configurações do tenant (perm settings:view)
 *
 * Fase 0 — somente leitura. Mutations (editar budget, vendors, etc.) serão
 * adicionadas em Fases posteriores quando os endpoints estiverem disponíveis.
 *
 * Resposta esperada do backend:
 *   {
 *     tenant: { name, plan, region },
 *     ai_vendors: Array<{ name, models, enabled }>,
 *     budget: { monthly_limit, alert_threshold_pct, block_on_exceed, spent, spent_pct },
 *     integrations: Array<{ name, status }>,
 *     security: { sso_enabled, mfa_required_admin, sandbox_ttl_min, audit_retention_days },
 *     members: Array<{ name, role, matrix_name }>
 *   }
 */
import { useQuery } from '@tanstack/react-query';
import { useApi } from './client';

/**
 * useSettings — lê as configurações do tenant.
 *
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useSettings() {
  const api = useApi();
  return useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get('/settings'),
    // Configurações mudam raramente — 5 min de stale é adequado
    staleTime: 5 * 60_000,
  });
}
